import objectFitImages from 'object-fit-images';

$(function() {
    const $images = $('.js-object-fit');
    objectFitImages($images);

    // onAjax fit images ie-11
    $(window).on('init.fitImages', function() {
        objectFitImages($images);
    });

});



// WEBPACK FOOTER //
// ./js/main/module/img-object-fit.js